import { create } from 'zustand';

export type FontSize = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

interface FontSizeState {
  size: FontSize;
  setSize: (size: FontSize) => void;
  increase: () => void;
  decrease: () => void;
}

const SIZES: FontSize[] = ['sm', 'md', 'lg', 'xl', '2xl'];
const SIZE_VALUES: Record<FontSize, string> = {
  sm: 'text-sm',     // 14px
  md: 'text-base',   // 16px
  lg: 'text-lg',     // 18px
  xl: 'text-xl',     // 20px
  '2xl': 'text-2xl', // 24px
};

const SIZE_PIXELS: Record<FontSize, number> = {
  sm: 14,
  md: 16,
  lg: 18,
  xl: 20,
  '2xl': 24,
};

export const useFontSizeStore = create<FontSizeState>((set) => {
  const storedSize = (localStorage.getItem('collab_font_size') || 'md') as FontSize;

  return {
    size: storedSize,

    setSize: (size: FontSize) => {
      localStorage.setItem('collab_font_size', size);
      set({ size });
    },

    increase: () => {
      set((state) => {
        const currentIndex = SIZES.indexOf(state.size);
        const nextIndex = Math.min(currentIndex + 1, SIZES.length - 1);
        const newSize = SIZES[nextIndex];
        localStorage.setItem('collab_font_size', newSize);
        return { size: newSize };
      });
    },

    decrease: () => {
      set((state) => {
        const currentIndex = SIZES.indexOf(state.size);
        const nextIndex = Math.max(currentIndex - 1, 0);
        const newSize = SIZES[nextIndex];
        localStorage.setItem('collab_font_size', newSize);
        return { size: newSize };
      });
    },
  };
});

export { SIZE_VALUES, SIZE_PIXELS };
